var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('h3',{staticClass:"landing__safeguards__item__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('p',{staticClass:"landing__safeguards__item__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }